<template>
    <section class="leafly-section bg-white cooperation-section">
        <div class="container mx-auto px-4">
            <div>
                <h2 class="leafly-section-title">Trusted by Leading Brands</h2>
                <p class="leafly-section-second-title mb-[20px]">Over a decade of excellence in packaging solutions</p>
            </div>

            <div class="flex flex-col lg:flex-row gap-12 items-start">
                <!-- 左侧：公司数据 -->
                <div class="cooperation-left" ref="statsContainerRef">
                    <div class="stats-container">
                        <div class="stat-item">
                            <div class="stat-number">{{ displayNumbers.years }}+</div>
                            <div class="stat-label">Years in Business</div>
                        </div>

                        <div class="stat-item">
                            <div class="stat-number">{{ displayNumbers.clients }}+</div>
                            <div class="stat-label">Clients</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">{{ displayNumbers.machines }}+</div>
                            <div class="stat-label">Advanced Machines</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">{{ displayNumbers.certcified }}%</div>
                            <div class="stat-label">Certified Materials</div>
                        </div>
                    </div>
                </div>
                <!-- 右侧：客户Logo轮播 -->
                <div class="cooperation-right flex-1" data-aos="fade-left">
                    <!-- 上面的 Swiper：向左移动 -->
                    <Swiper :modules="swiperModules" :slides-per-view="'auto'" :space-between="24" :loop="true" :autoplay="{
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                        reverseDirection: true,
                    }" :speed="3000" :allowTouchMove="false" class="clients-swiper clients-swiper-top">
                        <SwiperSlide v-for="(client, index) in clientLogos" :key="`top-${index}`" class="client-slide">
                            <div class="client-logo-wrapper sprite-logo" :style="{
                                backgroundImage: `url(${client.logo})`,
                                backgroundPosition: `${client.spriteX}px ${client.spriteY}px`
                            }" :title="client.name"></div>
                        </SwiperSlide>
                    </Swiper>

                    <!-- 下面的 Swiper：向右移动 -->
                    <Swiper :modules="swiperModules" :slides-per-view="'auto'" :space-between="24" :loop="true" :autoplay="{
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }" :speed="3000" :allowTouchMove="false" class="clients-swiper clients-swiper-bottom">
                        <SwiperSlide v-for="(client, index) in certifiedLogos" :key="`bottom-${index}`" class="client-slide">
                            <div class="client-logo-wrapper sprite-logo" :style="{
                                backgroundImage: `url(${client.logo})`,
                                backgroundPosition: `${client.spriteX}px ${client.spriteY}px`
                            }" :title="client.name"></div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import { Swiper, SwiperSlide } from 'swiper/vue'
    import { Autoplay } from 'swiper/modules'
    import { ref, onMounted, onUnmounted } from 'vue'

    // Swiper 模块
    const swiperModules = [Autoplay]

    // 客户Logo数据 - 使用CSS Sprite技术
    // 每张图片：宽度130px，高度78px
    // clientLogos: y=0，x从0开始，每张间隔130px
    const clientLogos = [
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: 0, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -130, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -260, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -390, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -520, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -650, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -780, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -910, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1040, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1170, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1300, spriteY: 0 },
        { name: 'Client', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1430, spriteY: 0 },
    ]

    // certifiedLogos: y=-78px，x从0开始，每张间隔130px
    const certifiedLogos = [
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: 0, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -130, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -260, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -390, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -520, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -650, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -780, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -910, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1040, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1170, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1300, spriteY: -78 },
        { name: 'Certified', logo: 'https://images.leaflypackaging.com/profile/upload/2026/01/29/clientAndCertified_20260129164845A003.webp', spriteX: -1430, spriteY: -78 },
    ]

    // 数字统计相关
    const statsContainerRef = ref<HTMLElement | null>(null)
    const hasAnimated = ref(false)

    // 目标数字
    const targetNumbers = {
        years: 14,
        clients: 150,
        machines: 80,
        certcified: 100
    }

    // 显示数字
    const displayNumbers = ref({
        years: 0,
        clients: 0,
        machines: 0,
        certcified: 0
    })

    // 数字递增动画函数
    function animateNumber(key: keyof typeof targetNumbers, target: number, duration: number = 2000) {
        const start = 0
        const startTime = Date.now()

        function update() {
            const elapsed = Date.now() - startTime
            if (elapsed < duration) {
                const progress = elapsed / duration
                const current = Math.floor(start + (target - start) * progress)
                displayNumbers.value[key] = current
                requestAnimationFrame(update)
            } else {
                displayNumbers.value[key] = target
            }
        }
        update()
    }

    // 启动所有数字动画
    function startAnimations() {
        if (hasAnimated.value) return
        hasAnimated.value = true

        animateNumber('years', targetNumbers.years, 2000)
        animateNumber('clients', targetNumbers.clients, 2000)
        animateNumber('machines', targetNumbers.machines, 2000)
        animateNumber('certcified', targetNumbers.certcified, 2000)
    }

    // Intersection Observer
    let observer: IntersectionObserver | null = null

    onMounted(() => {
        if (process.client && statsContainerRef.value) {
            observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !hasAnimated.value) {
                            startAnimations()
                        }
                    })
                },
                {
                    threshold: 0.3 // 当30%的元素可见时触发
                }
            )
            observer.observe(statsContainerRef.value)
        }
    })

    onUnmounted(() => {
        if (observer) {
            observer.disconnect()
        }
    })
</script>

<style scoped lang="scss">
    .cooperation-section {
        padding: 80px 0;

        @media (max-width: 768px) {
            padding: 60px 0;
        }
    }

    // 右侧Swiper样式
    .cooperation-right {
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        gap: 20px;
        align-items: stretch;

        .clients-swiper {
            width: 100%;
            padding: 20px 0;
            margin: 0;

            :deep(.swiper) {
                width: 100%;
                overflow: hidden;
                margin: 0;
                padding: 0;
            }

            :deep(.swiper-wrapper) {
                display: flex;
                align-items: center;
                margin: 0;
            }

            :deep(.swiper-slide) {
                margin: 0;
            }
        }

        .clients-swiper-top {
            margin-bottom: 0;
        }

        .clients-swiper-bottom {
            margin-top: 0;
        }

        .client-slide {
            width: auto !important;
            height: auto;
            display: flex;
            align-items: center;
        }

        .client-logo-wrapper {
            width: 200px;
            height: 120px;
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            flex-shrink: 0;

            &:hover {
                transform: translateY(-8px);
                box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
                border-color: #059669;
            }

            @media (max-width: 768px) {
                width: 160px;
                height: 100px;
                padding: 16px;
            }

            // CSS Sprite 样式
            &.sprite-logo {
                background-repeat: no-repeat;
                background-size: auto;
                background-position: center center;
                width: 130px;
                height: 78px;
                padding: 0;
                transition: all 0.3s ease;

                @media (max-width: 768px) {
                    width: 130px;
                    height: 78px;
                }
            }

            /* 默认状态：不带 gray-green 类的 logo（第二行） */
            &:not(.gray-green).sprite-logo {
                filter: grayscale(100%);
                opacity: 0.7;
            }

            /* 悬停状态：不带 gray-green 类的 logo */
            &:not(.gray-green):hover.sprite-logo {
                filter: grayscale(0%);
                opacity: 1;
            }

            /* 默认状态：带 gray-green 类的 logo（第一行） */
            &.gray-green {
                &.sprite-logo {
                    // 默认状态：无滤镜，显示原始颜色
                    filter: none;
                    opacity: 1;
                }

                &:hover.sprite-logo {
                    // 悬停时：将白色文字变为绿色，背景保持透明
                    filter: brightness(0) invert(1) sepia(100%) saturate(5000%) hue-rotate(120deg) brightness(0.9) contrast(1.1);
                    opacity: 1;
                }
            }
        }
    }


    // 统计区域容器样式
    .cooperation-left {
        width: 100%;
        flex-shrink: 0;

        @media (min-width: 1024px) {
            max-width: 400px;
        }

        .stats-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(2, 1fr);
            gap: 20px;

            .stat-item {
                padding: 20px;
                background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
                border-radius: 12px;
                border-left: 4px solid #059669;
                transition: all 0.3s ease;
                width: 100%;
                max-width: 180px;

                &:hover {
                    transform: translateX(8px);
                    box-shadow: 0 10px 25px rgba(5, 150, 105, 0.15);
                }

                .stat-number {
                    font-size: 3rem;
                    font-weight: 600;
                    color: #059669;
                    line-height: 1;
                    margin-bottom: 8px;

                    @media (max-width: 768px) {
                        font-size: 2.5rem;
                    }
                }

                .stat-label {
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #111827;
                    margin-bottom: 8px;
                }

                .stat-desc {
                    font-size: 0.875rem;
                    color: #6b7280;
                    line-height: 1.5;
                    margin: 0;
                }
            }
        }
    }

    // 响应式调整
    @media (max-width: 1024px) {
        .cooperation-left {
            max-width: 100%;

            .stats-container {
                grid-template-columns: repeat(2, 1fr);
                justify-items: center;

                .stat-item {
                    max-width: 200px;

                    &:hover {
                        transform: translateY(-8px);
                    }
                }
            }
        }
    }

    @media (max-width: 640px) {
        .cooperation-left {
            .stats-container {
                grid-template-columns: repeat(2, 1fr);
                gap: 16px;

                .stat-item {
                    max-width: 150px;
                    padding: 16px;
                }
            }
        }
    }
</style>
